import * as angular from 'angular';
import { NewSeatsMapTransformer } from '../transformer/ib-new-seat-map-transformer';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { AncCallSeatsMapService } from '../../../services/sea-cism/services/ib-call-seats-map-service';
import { AncGetCachedInformationService } from '../../../services/pac-prm/services/ib-get-cached-information-service';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { CommonsAncillariesService } from 'ib-web-commons/dist/app/core/http-services/ass-fass/ib-commons-ancillaries-service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DatalayerConstantsType } from 'ib-web-commons/dist/ib-datalayer/ib-datalayer-constants';
export class NewSeatsMapService {

    private slicesSeatmapInfo: any;
    private currentSeatmapData: any[];
    private isAnySeatUpdated: boolean = false;
    private deleteCurrentSeatmapData: any[];
    private totalSeatsPriceSubject: BehaviorSubject<any> = new BehaviorSubject({} as any);
    public readonly totalSeatsPrice: Observable<any> = this.totalSeatsPriceSubject.asObservable();
    private segmentSelectedSubject: BehaviorSubject<string> = new BehaviorSubject('');
    public readonly segmentSelected: Observable<string> = this.segmentSelectedSubject.asObservable();
    private aviosAncillariesSeatsSubject: BehaviorSubject<any[]> = new BehaviorSubject([] as any);
    public readonly aviosAncillariesSeats: Observable<any[]> = this.aviosAncillariesSeatsSubject.asObservable();
    private isSelectedSegmentFromMobileSummary: boolean;
    private currency: any;


    constructor (
        private AncCallSeatsMapService: AncCallSeatsMapService,
        private NewSeatsMapTransformer: NewSeatsMapTransformer,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $q: ng.IQService,
        private ModalServiceAncillaries: any,
        private AncGetCachedInformationService: AncGetCachedInformationService,
        private $location: ng.ILocationService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private CommonsModalService: CommonsModalService,
        private CommonsAncillariesService: CommonsAncillariesService,
        private $rootScope: CommonsRootScope,
        private CurrencyService: CurrencyService,
        private DatalayerConstants: DatalayerConstantsType,
        private $sce: ng.ISCEService,
        private $filter: ng.FilterFactory) {
    }

    ////////////////
    searchSeatsMap = (segment): any => {
        return new Promise<void>((resolve, reject) => {
            let seatsInfo;
            const searchSeatsMapSuccess = (seatsData: any): any => {
                const cachedInfo = this.localStorageService.get('bookingInfo');
                seatsInfo = seatsData;
                this.localStorageService.set('seatMap', seatsData);
                if (cachedInfo !== null) {
                    cachedInformationSuccess(cachedInfo);
                } else {
                    this.AncGetCachedInformationService.getCachedInformation().then(cachedInformationSuccess, searchSeatsMapError);
                }
            };

            const cachedInformationSuccess = (cachedData: any): any => {
                const transformedData = this.NewSeatsMapTransformer.generateSeatsMapRequest(seatsInfo, segment, cachedData);
                resolve(transformedData);
            };

            const searchSeatsMapError = (error: any): any => {
                reject(error);
                this.ModalServiceAncillaries.isNotWaiting();
                this.ModalServiceAncillaries.setErrorMessage(error.message);
                this.ModalServiceAncillaries.setErrorCode(error.internalErrorCode);
                this.ModalServiceAncillaries.setErrorGetOut(this.localStorageService.get('earlyCheckinCode'));
                this.CommonsModalService.showGenericError(error, null, null).result.then(angular.noop, angular.noop);
            };

            this.AncCallSeatsMapService.getSeatsMap(segment.segmentId).then(searchSeatsMapSuccess, searchSeatsMapError);
            return Promise.resolve();
        });
    };

    searchSeatsMapBySegment = (segmentId: string): any => {
        const deferred = this.$q.defer();
        let seatsInfo;
        const segment: any = segmentId ? {segmentId: segmentId} : this.localStorageService.get('seatMapSegment');
        // const segment: any = this.localStorageService.get('seatMapSegment');
        const searchSeatsMapSuccess = (seatsData: any): any => {
            const cachedInfo = this.localStorageService.get('bookingInfo');
            seatsInfo = seatsData;
            this.localStorageService.set('seatMap', seatsData);
            if (cachedInfo !== null) {
                cachedInformationSuccess(cachedInfo);
            } else {
                this.AncGetCachedInformationService.getCachedInformation().then(cachedInformationSuccess, searchSeatsMapError);
            }
        };

        const cachedInformationSuccess = (cachedData: any): any => {
            const transformedData = this.NewSeatsMapTransformer.generateSeatsMapRequest(seatsInfo, this.localStorageService.get('seatMapSegment'), cachedData);
            deferred.resolve(transformedData);
        };

        const searchSeatsMapError = (error: any): any => {
            deferred.reject(error);
            this.ModalServiceAncillaries.isNotWaiting();
            this.ModalServiceAncillaries.setErrorMessage(error.message);
            this.ModalServiceAncillaries.setErrorCode(error.internalErrorCode);
            this.ModalServiceAncillaries.setErrorGetOut(this.localStorageService.get('earlyCheckinCode'));
            this.CommonsModalService.showGenericError(error, null, null).result.then(angular.noop, angular.noop);
        };

        this.AncCallSeatsMapService.getSeatsMap(segment.segmentId).then(searchSeatsMapSuccess, searchSeatsMapError);
        return deferred.promise;
    };

    /**
     * Send information of seat map
     * Aqui se envía los datos del asiento
     * @param {*} updateSeatsInfo
     * @param {*} currency
     */
    updatePassengersSeats = (updateSeatsInfo: any, currency: any): any => {
        return new Promise<void>((resolve, reject) => {
            let update = {};
            const updatePassengersSeatsSuccess = (data: any): any => {
                const segment: any = this.localStorageService.get('seatMapSegment');
                // let aviosReq = <AncillariesModel.AviosAncillaries[]>[];
                // aviosReq = this.NewSeatsMapTransformer.genAviosSeatReq();
                // this.localStorageService.set('genAviosAncillariesSeat', aviosReq);
                if (this.AncillariesUtilsService.isCheckinFlow()) {
                    this.AncillariesUtilsService.updateCachedCheckinInformation(update, segment.segmentId);
                    this.NewSeatsMapTransformer.updateSeatCheckinInformation(updateSeatsInfo);
                    this.NewSeatsMapTransformer.updateAncillariesInformation(updateSeatsInfo, segment.segmentId);
                } else {
                    this.AncillariesUtilsService.updateSeatCachedInformation(update, segment.segmentId);
                    this.NewSeatsMapTransformer.updateSeatInformation(updateSeatsInfo);
                }

                resolve(data);

            };

            const updatePassengersSeatsError = (error: any): void => {
                reject(error);
            };
            if (updateSeatsInfo && Object.keys(updateSeatsInfo).length > 0) {
                if (this.localStorageService.get('currency') === null) {
                    this.localStorageService.set('currency', currency);
                }
                update = this.AncillariesUtilsService.generateFullSeatsMap(updateSeatsInfo);
                this.CommonsAncillariesService.updateAncillaries(update).then(updatePassengersSeatsSuccess, updatePassengersSeatsError);
            } else {
                resolve();
            }
            return Promise.resolve();

        });
    };

    loadSeatmapSegments (): any  {
        const seatmapRequests: any[] = this.getSlicesRequest();

        return new Promise((resolve, reject) => {

            Promise.all(seatmapRequests).then((slicesResponse: any) => {
                const slices: any[] = [];
                slicesResponse.forEach((slice: any, index: number) => {
                    slice = this.getSlicesDescriptions({segments: slice});
                    slice.segments = this.filterSegmentsWithoutSeatmap(slice);
                    this.setCurrentSeatmapSelectionIntoSegments(slice);
                    slice.showExpanded = false;
                    slices[index] = slice;

                });
                this.setConfirmedSeats(slices);
                this.setSlicesSeatmapInfo(slices);
                resolve(slices);
            }).catch(error => {
                reject(error);
            });
        });

    }

    private setConfirmedSeats (slices: any): void {
        let issuedData: any = [];
        let issuedItems: any[] = [];
        let freeItems: any[] = [];
        switch(this.localStorageService.get('flowApp')) {
                case this.AncillariesConstants.APPLICATION_FLOW.MMB:
                    issuedData = this.localStorageService.get('breakdownInfo');
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    issuedData = this.localStorageService.get('summaryInfo');
                    break;
        }
        // Add free confirmed seats to service response
        if (issuedData.freeItems && issuedData.freeItems.length > 0) {
            freeItems = issuedData.freeItems.filter((ancillary: any) => ancillary.type === 'SEAT');
            this.setSliceIssuedSeats(slices, freeItems, 'freeSeat');
        }

        // Add issued confirmed seats to service response
        if (issuedData.issuedItems && issuedData.issuedItems.length > 0) {
            issuedItems = issuedData.issuedItems.filter((ancillary: any) => ancillary.type === 'SEAT');
            this.setSliceIssuedSeats(slices, issuedItems, 'issuedSeat');
        }
    }

    private setSliceIssuedSeats (slices: any[], issuedItems: any[], issuedType: string): void {

        slices.forEach((slice: any) => {
            slice.segments.forEach((sliceSegment: any) => {
                issuedItems.forEach((ancillarySeat: any) => {
                    ancillarySeat.segments.forEach((issuedSegment: any) => {
                        if (sliceSegment.segmentInfo.id.toString() === issuedSegment.id.toString()) {
                            issuedSegment.passengers.forEach((issuedPassenger: any) => {
                                sliceSegment.passengersInfo.forEach((slicePassenger: any) => {
                                    if (slicePassenger.id.toString() === issuedPassenger.id.toString() && issuedPassenger.selected) {
                                        slicePassenger[issuedType] = issuedPassenger.seat;
                                        slicePassenger.seatPriceFormatted = this.getPassengersSeatPriceFormatted(slicePassenger, slicePassenger[issuedType]);
                                    }
                                });
                            });
                        }
                    });
                });
            });
        });
    }

    private getSlicesRequest (): any[] {
        switch(this.localStorageService.get('flowApp')) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                    return this.getSegmentIdsRequestBKI();
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    return this.getSegmentIdsRequestCKI();
                default:
                    return this.getSegmentIdsRequest();
        }
    }

    private getSegmentIdsRequestCKI (): any {
        const seatmapRequests: any[] = [];
        const seatmapSegment: any = this.localStorageService.get('seatMapSegment');
        const slices: any[] = this.getAvailableSegments(this.localStorageService.get('ancillariesSlices'));

        slices.forEach((slice: any) => {
            const sliceRequests: any[] = [];
            slice.segmentIds.forEach((segmentId: string) => {
                sliceRequests.push(this.searchSeatsMap({
                    pasId: seatmapSegment.pasId,
                    segmentId: segmentId
                }));
            });
            seatmapRequests.push(Promise.all(sliceRequests));
        });

        return seatmapRequests;
    }

    private getAvailableSegments (allSegments): any {
        const availableSlices: any[] = [];
        const ancillariesInfo: any = this.localStorageService.get('ancillariesInfo');

        ancillariesInfo.ancillaries.forEach(ancillarie => {
            if (ancillarie.type === 'SEAT') {
                allSegments.forEach(slice => {
                    const sliceInfo = {
                        id: slice.id,
                        segmentIds: []
                    };
                    slice.segmentIds.forEach(segment => {
                        if(this.checkSegmentAvailability(segment, ancillarie)) {
                            sliceInfo.segmentIds.push(segment);
                        }
                    });
                    if(sliceInfo.segmentIds.length > 0) {
                        availableSlices.push(sliceInfo);
                    }
                });
            }
        });
        return availableSlices;
    }

    private getAvailableSegmentsBKI (allSegments): any {
        const availableSlices: any[] = [];
        const ancillariesInfo: any = this.localStorageService.get('ancillariesInfo');

        ancillariesInfo.ancillaries.forEach(ancillarie => {
            if (ancillarie.type === 'SEAT') {
                allSegments.forEach(slice => {
                    const sliceInfo = [];
                    slice.forEach(segment => {
                        if(this.checkSegmentAvailability(segment.segmentId, ancillarie)) {
                            sliceInfo.push(segment);
                        }
                    });
                    if(sliceInfo.length > 0) {
                        availableSlices.push(sliceInfo);
                    }
                });
            }
        });
        return availableSlices;
    }

    private checkSegmentAvailability (segment, ancillarie): any {
        let segmentIsAvailable = false;
        ancillarie.segments.forEach(ancillariesSegment => {
            if(ancillariesSegment.id === segment && ancillariesSegment.status.code === 'AVAILABLE') {
                segmentIsAvailable = true;
            }
        });
        return segmentIsAvailable;
    }

    private getSegmentIdsRequest (): any {
        const seatmapRequests: any[] = [];
        const seatmapSegment: any = this.localStorageService.get('seatMapSegment');
        const slices: any[] = this.getAvailableSegments(this.localStorageService.get('ancillariesSlices'));

        slices.forEach((slice: any) => {
            const sliceRequests: any[] = [];
            slice.segmentIds.forEach((segmentId: string) => {
                sliceRequests.push(this.searchSeatsMap({
                    pasId: seatmapSegment.pasId.id,
                    segmentId: segmentId
                }));
            });
            seatmapRequests.push(Promise.all(sliceRequests));
        });

        return seatmapRequests;
    }
    private getSegmentIdsRequestBKI (): any {
        const seatmapRequests: any[] = [];
        const seatmapSegment: any = this.localStorageService.get('seatMapSegment');
        const slices: any[] = this.getAvailableSegmentsBKI(this.localStorageService.get('selectedTripSegments'));

        slices.forEach((slice: any) => {
            const sliceRequests: any[] = [];
            slice.forEach((segment: any) => {

                sliceRequests.push(this.searchSeatsMap({
                    pasId: seatmapSegment.pasId,
                    segmentId: segment.segmentId ? segment.segmentId : segment.id
                }));
            });
            seatmapRequests.push(Promise.all(sliceRequests));
        });

        return seatmapRequests;
    }

    private setCurrentSeatmapSelectionIntoSegments (slice: any): void {
        const currentSeatmapData: any = this.currentSeatmapData ? this.currentSeatmapData : this.localStorageService.get('currentSeatmapData');
        if(currentSeatmapData) {
            slice.segments.forEach((segment: any) => {
                const currentSegmentSelection = currentSeatmapData[segment.segmentInfo.id];
                if(currentSegmentSelection) {
                    const passengers = segment.passengersInfo.filter((passenger: any) => currentSegmentSelection[passenger.id]);
                    passengers.forEach((pass: any) => {
                        pass.currentSeat = currentSegmentSelection[pass.id].passengerInfo.currentSeat;
                        pass.initialSeat = currentSegmentSelection[pass.id].passengerInfo.initialSeat;
                        pass.seatPrice = currentSegmentSelection[pass.id].price;
                        pass.seatPriceFormatted = currentSegmentSelection[pass.id].priceFormatted;
                    });
                }
            });
        }

    }

    private filterSegmentsWithoutSeatmap (slice: any): any[] {
        const segmentsAvailable: any = this.localStorageService.get('seatsAvailableSegments');
        this.segmentSelectedSubject.next(segmentsAvailable[0]);
        return slice.segments.filter((segment: any) => segmentsAvailable.includes(segment.segmentInfo.id.toString()));
    }

    private getSlicesDescriptions (slice: any): any {
        const fullSlice = this.getOriginalSlice(slice.segments[0]?.segmentInfo.id);
        slice.totalSegments = slice.segments.length;
        if(fullSlice && fullSlice.segmentIds?.length !== slice.totalSegments) {
            slice.departure = this.getOriginDestination(fullSlice.segmentIds[0], true);
            slice.arrival = this.getOriginDestination(fullSlice.segmentIds[fullSlice.segmentIds.length - 1], false);
            slice.missingSegments = true;
        } else {
            slice.departure = slice.segments[0]?.segmentInfo.departure;
            slice.arrival = slice.segments[slice.segments.length - 1]?.segmentInfo.arrival;
            slice.missingSegments = false;
        }
        return slice;
    }

    private getOriginDestination (segmentId, isOrigin) {
        let cityInfo;
        const segmentsInfo: any = this.localStorageService.get('segmentsInfo');
        segmentsInfo.forEach(segment => {
            if (segment.id === segmentId) {
                if (isOrigin) {
                    cityInfo = segment.origin;
                } else {
                    cityInfo = segment.destination;
                }
            }
        });
        return cityInfo;
    }

    private getOriginalSlice (segmentId): any {
        let fullSlice;
        const ancillariesSlices: any = this.localStorageService.get('ancillariesSlices');
        ancillariesSlices.forEach(slice => {
            slice.segmentIds.forEach(segment => {
                if (segment === segmentId.toString()) {
                    fullSlice = slice;
                }
            });
        });
        return fullSlice;
    }

    /**
     *  Exit of seat map and prevoius check conditions:
     *  1 - Early flow
     *     - Is obligatory and it´s necessary select a set for continue flow
     *     - Check if all passenger have a seat and we show modal window for advise user it´s necessary select seat for all passengers
     *  2- In flows different of early if user change the seat and try close the seat map we show the confirmation modal for advise the user
     *
     */
    cancelSeatMap (): any {
        if (this.AncillariesUtilsService.isCheckinFlow()) {
            if (this.localStorageService.get('earlyCheckinCode')) {
                this.showModalEarlyCKI();
            } else if (this.checkPendingConfirmSeats()) {
                return this.ModalServiceAncillaries.openModalWarningSeatMap(
                    'ib-modal-map-seats-cancel',
                    'ib-modals ib-modals--sm ib-modals--sm-no-margin ib-modals--loading ib-modals--new-seats-big',
                    ''
                ).result.then(() => {
                    angular.noop;
                }, () => {
                    return this.deleteCurrentSeatMapDataAndDismiss();
                });
            } else {
                this.$rootScope.$broadcast('updateDatalayer');
                this.$rootScope.$broadcast('updatePageType');
                return this.dismissModal();
            }
        } else {
            if (this.checkPendingConfirmSeats()) {
                return this.ModalServiceAncillaries.openModalWarningSeatMap(
                    'ib-modal-map-seats-cancel',
                    'ib-modals ib-modals--sm ib-modals--sm-no-margin ib-modals--loading ib-modals--new-seats-big',
                    ''
                ).result.then(() => {
                    angular.noop;
                }, () => {
                    return this.deleteCurrentSeatMapDataAndDismiss();
                });
            } else {
                this.$rootScope.$broadcast('updateDatalayer');
                this.$rootScope.$broadcast('updatePageType');
                return this.dismissModal();
            }
        }
    }

    /**
     * Check if any passenger not have seat
     */
    checkPendingConfirmSeats = (): any => {
        let pendingSeats = false;

        if(!this.currentSeatmapData) {
            return false;
        }

        this.slicesSeatmapInfo.forEach((slice: any) => {
            slice.segments.forEach((segment: any) => {
                segment.passengersInfo.forEach((passenger: any) => {
                    if (passenger.initialSeat.row !==
                        passenger.currentSeat.row ||
                        passenger.initialSeat.column !==
                        passenger.currentSeat.column) {
                        pendingSeats = true;
                    }
                });
            });
        });
        return pendingSeats;
    };

    /**
     * Return total price of all seats selected
     * @param {Object} evt Event
     * @param {Object} seat Seat information
     */
    calculateTotalSeatPrice (slicesInfo: any, currency: any): void {
        let totalSeatsPrice = 0;

        slicesInfo.forEach((slice: any)=> {
            slice.segments.forEach((segment: any) => {
                totalSeatsPrice = segment.passengersInfo
                    .filter((passenger: any) => this.isPassengerDifferentSeat(passenger))
                    .map((passenger: any) => passenger.seatPrice)
                    .reduce((segmentPrice: number, seatPrice: number) => segmentPrice + seatPrice, totalSeatsPrice);
            });
        });
        const totalSeatsPriceFormatted = this.CurrencyService.formatPrice(
            currency,
            totalSeatsPrice,
            false,
            false,
            false
        );

        this.currency = currency;
        this.totalSeatsPriceSubject.next({total: totalSeatsPrice, totalFormatted: totalSeatsPriceFormatted});

    }

    /**
     * Go to ibcose
     */
    goToInitFlow = (): void => {
        this.$location.path(this.AncillariesConstants.PAGES_ROUTES.SEARCH_BOOKING);
    };

    /**
     * Dismiss seat map modal
     */
    dismissModal (): Promise<any> {
        return new Promise((resolve) => {
            resolve(true);
        });
    }

    deleteCurrentSeatMapDataAndDismiss = (): any => {
        this.setSlicesSeatmapInfo(undefined);
        this.setCurrentSeatmapData(undefined);
        // this.localStorageService.remove('genAviosAncillariesSeat');
        return this.dismissModal();
    };



    /**
     * Check if segment is the first of all
     */
    isFirstSegment = (): any => {
        return this.NewSeatsMapTransformer.isFirstSegment();
    };

    setSlicesSeatmapInfo (slicesInfo): void {
        this.slicesSeatmapInfo = slicesInfo;
    }

    getSlicesSeatmapInfo (): any {
        return this.slicesSeatmapInfo;
    }

    setCurrentSeatmapData (currentSeatmapData: any): void {
        this.currentSeatmapData = currentSeatmapData;
    }

    getCurrentSeatmapData (): any {
        return this.currentSeatmapData;
    }
    setDeleteCurrentSeatmapData (deleteCurrentSeatmapData: any[]): void {
        this.deleteCurrentSeatmapData = deleteCurrentSeatmapData;
    }

    getDeleteCurrentSeatmapData (): any {
        return this.deleteCurrentSeatmapData;
    }
    /**
     * current segment selected on seatmap for desktop
     */
    setSegmentSelected (segment: string): void {
        this.segmentSelectedSubject.next(segment);
    }

    setSeatAvios (seatAvios: any[]): void {
        this.aviosAncillariesSeatsSubject.next(seatAvios);
    }

    openModalAviosSeatAncillaries (aviosAncillariesSeat: any): void {
        const modalObject = {aviosAncillariesReq: {}, passenger: {}};
        modalObject.aviosAncillariesReq = this.NewSeatsMapTransformer.genAviosSeatAncillariesReq(aviosAncillariesSeat);
        modalObject.passenger = this.localStorageService.get('bookingInfo');
        this.ModalServiceAncillaries.openNewSeatsAviosAccumulatedModal(modalObject).result.then(() => {}, () => {});
    }

    backToMain = (goToHome) => {
        const actualStepFlow = this.localStorageService.get('actualStepFlow');
        const flowApp = this.localStorageService.get('flowApp');
        const onHoldOptions = this.localStorageService.get('onHoldOptions') || null;
        const dataModal = { idModal: this.DatalayerConstants.DATALAYER_MODAL_ID.BACK_MAIN_HEADER_MODAL };
        const isFlowBKIOnHold = (flowApp === 'BBKI' && onHoldOptions) && (actualStepFlow === 'ibcmtv' || actualStepFlow === 'ibpurc');

        if (isFlowBKIOnHold) {
            /* SHOW MODAL DE ONHOLD ANCILLARIES & PAYMENTS BKI */
            this.ModalServiceAncillaries.showOnholdModal(true, dataModal).result.then(() => {
                this.eventBackToMainRoot(goToHome);
            }, () => {});
        } else {
            this.showModalBackToMain(goToHome, flowApp);
        }
    };
    eventBackToMainRoot = (goToHome) => {
        this.$rootScope.$broadcast('backToMainRoot', goToHome);
    };

    showModalBackToMain = (goToHome, flowApp) => {
        this.ModalServiceAncillaries.showBackToMainModal(true, flowApp).result.then(
            () => {
                this.eventBackToMainRoot(goToHome);
            }, () => { }
        );
    };

    initRenacen3dScript () {
        const envCopy: any = {};
        (Object).assign(envCopy, (<any>window).env);

        let renacen3dFeaturesCss: string;
        let renacen3dFeaturesJs: string;

        if (envCopy.production) {
            renacen3dFeaturesCss = this.$sce.trustAsResourceUrl(this.AncillariesConstants.DEFAULT_ENDPOINTS.renacen3dFeaturesCssPRO);
            renacen3dFeaturesJs = this.$sce.trustAsResourceUrl(this.AncillariesConstants.DEFAULT_ENDPOINTS.renacen3dFeaturesJsPRO);
        } else {
            renacen3dFeaturesCss = this.$sce.trustAsResourceUrl(this.AncillariesConstants.DEFAULT_ENDPOINTS.renacen3dFeaturesCssPRO);
            renacen3dFeaturesJs = this.$sce.trustAsResourceUrl(this.AncillariesConstants.DEFAULT_ENDPOINTS.renacen3dFeaturesJsPRO);
        }

        const script = document.createElement('script');
        script.src = renacen3dFeaturesJs;
        document.querySelector('body').prepend(script);
        const link = document.createElement('link');
        link.href = renacen3dFeaturesCss;
        link.type = 'text/css';
        link.rel = 'stylesheet';
        document.querySelector('body').prepend(link);
    }

    setIsSelectedSegmentFromMobileSummary (selected: boolean): void {
        this.isSelectedSegmentFromMobileSummary = selected;
    }

    getIsSelectedSegmentFromMobileSummary (): boolean {
        return this.isSelectedSegmentFromMobileSummary;
    }

    /**
    * Delete seats of segment selected on basket and update quanty on model on new seat map
    * @param {*} idDeleteSegment segment
    * @param {*} dataSeat Amount of seats deleted
    */
    updateNewSeatmapDeleteSeat (idDeleteSegment: string, passengers: any[]): void {
        let currentSeatmapData = this.currentSeatmapData ? this.currentSeatmapData : this.localStorageService.get('currentSeatmapData');
        if(currentSeatmapData && currentSeatmapData[idDeleteSegment]) {
            passengers.forEach((passenger: any) => {
                delete currentSeatmapData[idDeleteSegment][passenger.id];
            });
            if (Object.keys(currentSeatmapData[idDeleteSegment]).length === 0 ) {
                delete currentSeatmapData[idDeleteSegment];
            }

            if (Object.keys(currentSeatmapData).length === 0 ) {
                currentSeatmapData = undefined;
            }

            this.setSlicesSeatmapInfo(undefined);
            this.setCurrentSeatmapData(currentSeatmapData);
            this.localStorageService.set('currentSeatmapData', currentSeatmapData);

            passengers.map((passenger: any) => this.setSeatAvios(this.NewSeatsMapTransformer.deleteAviosUnselectedSeat(idDeleteSegment, passenger.id)));

            this.localStorageService.set('flightAviosInfo', this.NewSeatsMapTransformer.genAviosSeatAncillariesReq(this.aviosAncillariesSeatsSubject.value));
            this.localStorageService.set('genAviosAncillariesSeat', this.aviosAncillariesSeatsSubject.value);
        }
    }

    confirmSelectedSeats (): Promise<void> {

        return new Promise(async (resolve, reject) => {
            if(this.deleteCurrentSeatmapData && this.deleteCurrentSeatmapData.length > 0) {
                resolve(await this.removeSelectedSeats());
            } else {
                resolve(await this.updateSeats());
            }
        });
    }

    setIsAnySeatUpdated (isAnySeatUpdated: boolean): void {
        this.isAnySeatUpdated = isAnySeatUpdated;
    }

    getIsAnySeatUpdated (): boolean {
        return this.isAnySeatUpdated;
    }

    private isPassengerDifferentSeat (passenger: any): boolean {
        return (
            (passenger.initialSeat.row !== passenger.currentSeat.row
            || passenger.initialSeat.column !== passenger.currentSeat.column)
            && !passenger.issuedSeat)
        || (passenger.issuedSeat
            && (passenger.currentSeat.row !== passenger.issuedSeat.row
            || passenger.currentSeat.column !== passenger.issuedSeat.column));
    }

    private getPassengersSeatPriceFormatted (passengerInfo: any, issuedSeat: any): string {
        let seatPriceFormatted: string;

        if(passengerInfo.freeSeat && this.isSelectedSeat(passengerInfo.currentSeat, issuedSeat)) {
            seatPriceFormatted = this.$filter('translate')('CKIANCSEATS_FREE_PRICE');
        } else if(passengerInfo.issuedSeat && this.isSelectedSeat(passengerInfo.currentSeat, issuedSeat)) {
            seatPriceFormatted = this.$filter('translate')('NEW_SEATS_MAP_PAID');
        } else {
            seatPriceFormatted = passengerInfo.seatPriceFormatted;
        }

        return seatPriceFormatted;
    }

    private isSelectedSeat (issuedSeat: any, selectedSeat: any): boolean {

        return issuedSeat.row === selectedSeat.row
            && issuedSeat.column === selectedSeat.column;
    }

    private removeSelectedSeats (): Promise<void> {
        return new Promise((resolve, reject) => {
            this.CommonsAncillariesService.deleteAncillarie(this.deleteCurrentSeatmapData).then(
                async (deleteAncillarieResponse: any) => {
                    this.deleteBasketAndCachedSeats(deleteAncillarieResponse);
                    resolve(await this.updateSeats());
                },
                (error: any) => {
                    this.ModalServiceAncillaries.showGenericError(error, false, undefined);
                    reject(error);
                });
        });
    }

    private async updateSeats (): Promise<void> {
        if (this.currentSeatmapData && this.isAnySeatUpdated) {
            await this.updatePassengersSeats(this.currentSeatmapData, this.currency).then(() => {
                this.updatePassengersSeatsSuccess();
            },
            (error: any) => {
                if(error.errorCode === 409) {
                    this.showErrorModalSomeSeats(error.data[0].segments);
                    this.updatePassengersSeatsSuccess();
                    return Promise.resolve();

                } else {
                    Promise.reject(error);
                }
            });
        } else {
            return Promise.resolve();
        }
    }

    private updatePassengersSeatsSuccess (): Promise<void>  {
        this.updateBasket();
        this.localStorageService.set('currentSeatmapData', this.currentSeatmapData);
        this.setCurrentSeatmapData(undefined);
        this.isAnySeatUpdated = false;

        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
        this.localStorageService.set('genAviosAncillariesSeat', this.aviosAncillariesSeatsSubject.value);
        this.localStorageService.set('flightAviosInfo', this.NewSeatsMapTransformer.genAviosSeatAncillariesReq(this.aviosAncillariesSeatsSubject.value));

        return Promise.resolve();
    }

    private showErrorModalSomeSeats (segments: any[]): void {
        const errorSeats: any[] = [];
        segments.forEach((segment: any) => {
            if(this.currentSeatmapData[segment.id]) {
                const originDestination = this.getOriginDestinationError(segment.id);
                const segmentSeats: string[] = [];
                segment.passengers.forEach((passenger: any) => {
                    const passengerSeat = this.currentSeatmapData[segment.id][passenger.id];
                    if(passengerSeat) {
                        const errorSeat: string = passengerSeat.seat.row + passengerSeat.seat.column;
                        segmentSeats.push(errorSeat);
                    }
                    delete this.currentSeatmapData[segment.id][passenger.id];
                    if (Object.keys(this.currentSeatmapData[segment.id]).length === 0) {
                        delete this.currentSeatmapData[segment.id];
                    }
                });
                errorSeats.push({originDestination: originDestination, seats: segmentSeats});
            }
        });

        const modalErrorObject = {
            title: 'NEW_SEATS_MAP_SEATS_SELECTION_ERROR_TITLE',
            segments: errorSeats
        };
        this.ModalServiceAncillaries.openErrorSeatsSelectionModal(modalErrorObject);
    }

    private getOriginDestinationError (segmentId: string): string {
        const segment = this.getSelectedSegment({segmentId: segmentId});
        const originDestination: string =
            segment.segmentInfo.departure.description + '(' + segment.segmentInfo.departure.code + ') - '
            + segment.segmentInfo.arrival.description + '(' + segment.segmentInfo.arrival.code + ')';

        return originDestination;
    }

    getSelectedSegment (selectedSegment: any): any {
        return this.slicesSeatmapInfo.find((slice: any)=>
            slice.segments.find((segment: any) =>
                segment.segmentInfo.id.toString() === selectedSegment.segmentId.toString()))
            .segments.find((segment: any) => segment.segmentInfo.id.toString() === selectedSegment.segmentId.toString());
    }


    private updateBasket (): void {
        for (let i = 0; i < Object.keys(this.currentSeatmapData).length; i++) {
            const segmentId = Object.keys(this.currentSeatmapData)[i];
            const updateInfo = this.transformDataToUpdateModel(this.currentSeatmapData[segmentId]);
            this.$rootScope.$broadcast('updateHeaderSeats', {
                segmentId: segmentId,
                passengers: updateInfo,
                passengersInfo: updateInfo.map((seatInfo: any) => seatInfo.passengerInfo)
            });
        }
    }

    private transformDataToUpdateModel (segment: any): any {
        const updateData = [];
        for(let i = 0; i < Object.keys(segment).length; i++) {
            const passengerId: string = Object.keys(segment)[i];
            if(!segment[passengerId].isPreBooked) {
                updateData.push(segment[passengerId]);
            }
            // to identify current prebooked seats
            segment[passengerId].isPreBooked = true;
        }
        return updateData;
    }

    private deleteBasketAndCachedSeats (deleteAncillarieResponse: any): void {
        this.deleteCurrentSeatmapData.forEach((seats: any) => {
            seats.segments.forEach((segment: any) => {
                let seatsDeleted = 0;
                let updatedSeats: any[] = [];
                ({ updatedSeats, seatsDeleted } = this.updatePassengerSeatsToDelete(this.currentSeatmapData[segment.id], segment.passengers, seatsDeleted));
                updatedSeats.forEach((passenger: any) => {
                    this.$rootScope.$broadcast('updateHeaderSeats', {
                        segmentId: segment.id,
                        passengers: [passenger],
                        passengersInfo: [passenger.passengerInfo],
                        isDeletedFromSeatmap: true
                    });
                });

                const seatsToDelete = deleteAncillarieResponse.ancillaries
                    .find((ancillary: any) => ancillary.type === 'SEAT').segments
                    .filter((segmentToDelete: any) => segmentToDelete.id === segment.id);
                this.$rootScope.$broadcast('deleteSeats', {
                    seats: [{segments: seatsToDelete, type: 'SEAT'}],
                    amount: seatsDeleted
                });
            });
        });
        this.deleteCurrentSeatmapData = [];
    }

    private updatePassengerSeatsToDelete (segment: any, passengers: string[], seatsDeleted: number): any {
        const updatedSeats: any[] = [];

        passengers.forEach((passengerId: string) => {
            segment[passengerId].isDeletedFromSeatmap = true;
            seatsDeleted++;
            updatedSeats.push(segment[passengerId]);
        });

        return {updatedSeats, seatsDeleted};
    }

    showModalEarlyCKI (): void {
        this.ModalServiceAncillaries.openModalWarningSeatMap(
            'ib-modal-close-warning-new-seats-map',
            'ib-modals ib-modals--md',
            ''
        ).result.then(
            () => { },
            () => {
                this.goToInitFlow();
            });
    }


    getIfUnselectedSegments (): boolean {
        return this.slicesSeatmapInfo.some((slice: any) => slice.segments
            .find((segment: any) => segment.passengersInfo
                .find((passenger: any) => passenger.currentSeat.row === '' || passenger.currentSeat.column === '')));
    }
}

NewSeatsMapService.$inject = ['AncCallSeatsMapService', 'NewSeatsMapTransformer', 'localStorageService', '$q', 'ModalServiceAncillaries', 'AncGetCachedInformationService', '$location', 'AncillariesUtilsService', 'AncillariesConstants', 'CommonsModalService', 'CommonsAncillariesService', '$rootScope', 'CurrencyService', 'DatalayerConstants', '$sce', '$filter'];
try {
    const mod = angular.module('ib-new-seat-map-module');
    mod.service(
        'NewSeatsMapService',
        NewSeatsMapService
    );
} catch (error) {
    const mod = angular.module('ib-new-seat-map-module', []);
    mod.service(
        'NewSeatsMapService',
        NewSeatsMapService
    );
}